<template>
  <i-header class="nav-panel">
    <div :class="['layout-container', isFullWidthRoute ? 'full-width' : '']">
      <div class="nav-panel-row">
        <div class="nav-panel-cell nav-panel-cell--left">
          <a class="nav-panel-link" href="/app">
            <logo :only-icon="true" />
          </a>
          <companies />
          <nav-menu />
        </div>
        <div class="nav-panel-cell nav-panel-cell--search">
          <search-bar />
        </div>
        <div class="nav-panel-cell nav-panel-cell--profile">
          <profile-menu />
        </div>
      </div>
    </div>
    <!-- <row :class="['layout-container', isFullWidthRoute ? 'full-width' : '']">
      <i-col span="13" class="nav-panel-left">
        <a class="nav-panel-link" href="/app">
          <logo :only-icon="true" />
        </a>
        <companies />
        <nav-menu />
      </i-col>
      <i-col span="6">
        <search-bar />
      </i-col>
      <i-col span="5">
        <profile-menu />
      </i-col>
    </row> -->
  </i-header>
</template>

<script>
import SearchBar from '@/components/search/search-bar'
import Logo from '@/components/logo/logo'
import Companies from './companies'
import NavMenu from './nav-menu'
import ProfileMenu from './profile-menu'

export default {
  components: {
    Logo,
    Companies,
    NavMenu,
    SearchBar,
    ProfileMenu
  },
  computed: {
    isFullWidthRoute () {
      const fullWidthModules = [
        'contracts/edit',
        'contragents/edit',
        'time-table',
        'experience',
        'register',
        'dashboard/actual/month',
        'dashboard/actual/week',
        'reports/report_2',
        'reports/report_3',
        'reports/report_7'
      ]

      return fullWidthModules.some(m => this.$route.path.indexOf(m) > -1)
    }
  }
}
</script>

<style lang="less">
.nav-panel {
  &.ivu-layout-header {
    height: 40px;
    padding: 0;
  }
  &-link {
    cursor: pointer;
  }

  &-row {
    display: flex;
    justify-content: space-between;
  }

  &-cell {
    display: flex;
    align-items: center;
    height: 40px;

    &--search {
      margin-left: auto;
      margin-right: 32px;
      flex: 1;
      max-width: 480px;
    }
  }
}
.layout-actions {
  margin-left: auto;
  width: 192px;
}
.layout-avatar {
  margin-left: auto;
  margin-right: 20px;
  line-height: 40px;
}
</style>
